import React from 'react'
import { Route, useRouteMatch } from 'react-router'
import { positionDefault } from '@reach/popover'

import {
  Tooltip,
  TooltipShortcut,
  Dropdown,
  SelectInput,
  SelectTriggerUnstyled,
} from '@sketch/components'
import { routes } from '@sketch/modules-common'
import { useSearch } from 'modules/shares/hooks/useSearch'
import {
  useGetDocumentListSettingsQuery,
  WorkspaceMinimalFragment,
} from '@sketch/gql-types'

import {
  Filter,
  IconWrapper,
  StyledCheckbox,
  StyledChevron,
  StyledSelectPopover,
  ToggleWrapper,
  StyledDropdownItem,
} from './SearchBar.styles'

export interface SearchBarProps {
  userRole: WorkspaceMinimalFragment['userRole']
}

const getPlaceholderByPath = (path: string) => {
  switch (path) {
    case routes.WORKSPACE_TRASH.template():
      return 'Search all documents in Trash'
    case routes.WORKSPACE_LIBRARIES.template():
    case routes.DESIGN_SYSTEM.template():
      return 'Search Libraries'
    case routes.WORKSPACE_SHARED_WITH_ME.template():
      return 'Search Shared with Me'
    case routes.WORKSPACE_TEMPLATES.template():
      return 'Search Templates'
    case routes.WORKSPACE_DRAFTS.template():
      return 'Search My Drafts'
    default:
      return 'Search'
  }
}

export const SearchBar = ({ userRole }: SearchBarProps) => {
  const { data, updateQuery } = useGetDocumentListSettingsQuery()
  const { showDocumentsInProjects } = data || {}
  const { search, setSearch } = useSearch()

  const shouldShowSearchOptions = userRole !== 'GUEST'

  const { path } = useRouteMatch()
  const inputPlaceholder = getPlaceholderByPath(path)

  return (
    <Tooltip
      content={
        <>
          Search
          <TooltipShortcut>Press /</TooltipShortcut>
        </>
      }
      disableWhenTouchDevice
      placement="bottom-start"
    >
      <Filter
        onChange={setSearch}
        value={search}
        name="search"
        placeholder={inputPlaceholder}
      >
        <Route path={routes.WORKSPACE_SHARES.template()}>
          {shouldShowSearchOptions && (
            <SelectInput value={'Options'}>
              <SelectTriggerUnstyled>
                <ToggleWrapper>
                  Options
                  <IconWrapper>
                    <StyledChevron />
                  </IconWrapper>
                </ToggleWrapper>
              </SelectTriggerUnstyled>
              <StyledSelectPopover position={positionDefault}>
                <Dropdown.Header>Show Documents</Dropdown.Header>
                <StyledDropdownItem>
                  <StyledCheckbox
                    checked={showDocumentsInProjects}
                    label="Include documents in Projects"
                    onChange={event =>
                      updateQuery(previous => ({
                        ...previous,
                        showDocumentsInProjects: !showDocumentsInProjects,
                      }))
                    }
                  />
                </StyledDropdownItem>
                {/* Reset is hidden for now until we don't have more search options to reset */}
                {/* <Dropdown.Divider />
            <StyledDropdownResetItem
              disabled={includeDocsInProjects === true}
              onClick={() => onIncludeDocsInProjectsChange(true)}>
              <StyledResetIcon disabled={includeDocsInProjects === true} />{' '}
              Reset
            </StyledDropdownResetItem> */}
              </StyledSelectPopover>
            </SelectInput>
          )}
        </Route>
      </Filter>
    </Tooltip>
  )
}
